export { default } from './ProductHeaderBanner';
